import commonActions from '../commons/actions'

const actions = {
    ...commonActions,
}

export default actions